var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#D8E7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11517_43573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 35C24.17 35 26.7801 34.2082 29.0002 32.7248C31.2203 31.2414 32.9506 29.133 33.9724 26.6662C34.9942 24.1994 35.2615 21.485 34.7406 18.8663C34.2197 16.2475 32.934 13.8421 31.0459 11.9541C29.1579 10.0661 26.7525 8.78031 24.1337 8.2594C21.515 7.7385 18.8006 8.00585 16.3338 9.02763C13.867 10.0494 11.7586 11.7797 10.2752 13.9998C8.79176 16.2199 8 18.83 8 21.5C8.00387 25.0792 9.42743 28.5108 11.9583 31.0417C14.4892 33.5726 17.9208 34.9961 21.5 35ZM21.5 13.625C21.8338 13.625 22.16 13.724 22.4375 13.9094C22.715 14.0948 22.9313 14.3584 23.059 14.6667C23.1868 14.9751 23.2202 15.3144 23.1551 15.6417C23.09 15.9691 22.9292 16.2697 22.6932 16.5057C22.4572 16.7417 22.1566 16.9025 21.8292 16.9676C21.5019 17.0327 21.1626 16.9993 20.8542 16.8716C20.5459 16.7438 20.2823 16.5275 20.0969 16.25C19.9115 15.9725 19.8125 15.6463 19.8125 15.3125C19.8125 14.865 19.9903 14.4357 20.3068 14.1193C20.6232 13.8028 21.0524 13.625 21.5 13.625ZM20.375 19.25H21.5C22.0967 19.25 22.669 19.4871 23.091 19.909C23.5129 20.331 23.75 20.9033 23.75 21.5V28.25C23.75 28.5484 23.6315 28.8345 23.4205 29.0455C23.2095 29.2565 22.9234 29.375 22.625 29.375C22.3266 29.375 22.0405 29.2565 21.8295 29.0455C21.6185 28.8345 21.5 28.5484 21.5 28.25V21.5H20.375C20.0766 21.5 19.7905 21.3815 19.5795 21.1705C19.3685 20.9595 19.25 20.6734 19.25 20.375C19.25 20.0766 19.3685 19.7905 19.5795 19.5795C19.7905 19.3685 20.0766 19.25 20.375 19.25Z",
    fill: "#3F7CDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11517_43573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLg);
export default __webpack_public_path__ + "static/media/info-lg.a69923d469b8b444f2db9e84ef523e3a.svg";
export { ForwardRef as ReactComponent };